import {AxiosResponse} from 'axios'
import axiosApi from '../api/axios-api'

export default {
    accountFind(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/find`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    accountSave(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/save`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    accountView(id: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/view/` + id, null)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
    accountUpdate(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/update`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	accountDelete(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/delete`, request)
				.then(function (response) {
					resolve(response);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	},
    accountList(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/list`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	accountImport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostImport(`/account/import`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	accountImportProceed(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPost(`/account/import/proceed`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
	accountExport(request: any): Promise<AxiosResponse<any>> {
		return new Promise((resolve, reject) => {
			axiosApi.axiosPostExport(`/account/export`, request)
			.then(function (response) {
				resolve(response);
			})
			.catch(function (error) {
				reject(error);
			});
		});
    },
}
